import React from "react";
import { Box, Typography } from "@mui/material";
import { SLATE, INDIGO } from "../constants/Colors";

export default function ComingSoon({ feature }) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 14,
        px: 4,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "16px",
          bgcolor: INDIGO[50],
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
          fontSize: "2rem",
        }}
      >
        🚧
      </Box>
      <Typography sx={{ fontSize: "1.25rem", fontWeight: 700, color: SLATE[900], mb: 1 }}>
        Coming Soon
      </Typography>
      <Typography sx={{ fontSize: "0.875rem", color: SLATE[500], maxWidth: 340 }}>
        {feature
          ? `${feature} is currently under development and will be available soon.`
          : "This feature is currently under development and will be available soon."}
      </Typography>
    </Box>
  );
}
